module.exports = __webpack_public_path__ + "static/media/replayBtn.70638cc8.svg";